/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'glyph/12/close': {
    width: 10,
    height: 10,
    viewBox: '0 0 10 10',
    data: '<path pid="0" _fill="#354046" d="M9.72.293a1 1 0 00-1.415 0L5.012 3.586 1.72.293A1 1 0 00.305 1.707L3.598 5 .305 8.293A1 1 0 101.72 9.707l3.293-3.293 3.293 3.293A1 1 0 009.72 8.293L6.426 5 9.72 1.707a1 1 0 000-1.414z" style="mix-blend-mode:multiply"/>'
  }
})
